var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-register"},[_c('PageHeader',{attrs:{"title":"Registration"}}),_c('RegisterForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }